"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../../icons");
var variables_1 = require("../../../style/variables");
var DeltaDisplay_1 = __importDefault(require("../../DeltaDisplay"));
var Text_1 = __importDefault(require("../../Text"));
var Title_1 = __importDefault(require("../../Text/Title"));
var Tooltip_1 = __importDefault(require("../../Tooltip"));
var layout_1 = require("../../layout");
var lodash_1 = require("lodash");
var dataMetricStyles = {
    container: react_1.css({
        padding: 16,
        backgroundColor: "var(" + variables_1.RootColor.White + ")",
        border: '1px solid #E5E7EB',
        borderRadius: 8,
    }),
    header: react_1.css({
        marginBottom: 8,
    }),
    title: react_1.css({
        color: '#4D5761',
    }),
    helperIcon: react_1.css({
        color: '#9DA4AE',
    }),
    value: react_1.css({
        color: '#111927',
        lineHeight: 1.2,
    }),
    deltaDescription: react_1.css({
        color: '#6C737F',
    }),
};
var DataMetric = function (_a) {
    var deltaUnit = _a.deltaUnit, deltaValue = _a.deltaValue, value = _a.value, deltaDescription = _a.deltaDescription, title = _a.title, infoText = _a.infoText, deltaPrecision = _a.deltaPrecision, deltaTooltipProps = _a.deltaTooltipProps, invertDeltaColors = _a.invertDeltaColors;
    return (react_1.jsx("div", { css: dataMetricStyles.container },
        react_1.jsx(layout_1.Flex, { alignItems: "center", gap: 4, css: dataMetricStyles.header },
            react_1.jsx(Title_1.default, { css: dataMetricStyles.title }, title),
            infoText ? react_1.jsx(Tooltip_1.default, { overlay: infoText },
                react_1.jsx(icons_1.HelpCircle, { css: dataMetricStyles.helperIcon })) : undefined),
        react_1.jsx(Text_1.default.DisplayHeading, { size: "sm", css: dataMetricStyles.value }, typeof value === 'number' ? value.toLocaleString() : value),
        (!lodash_1.isNil(deltaValue) || deltaDescription) ?
            react_1.jsx(Tooltip_1.default, __assign({ overlay: deltaTooltipProps === null || deltaTooltipProps === void 0 ? void 0 : deltaTooltipProps.overlay }, deltaTooltipProps),
                react_1.jsx(layout_1.Flex, { gap: 8, alignItems: "center", css: { marginTop: 8, width: 'max-content' } },
                    !lodash_1.isNil(deltaValue) &&
                        react_1.jsx(DeltaDisplay_1.default, { value: deltaValue, unit: deltaUnit || '', precision: deltaPrecision, invertColors: invertDeltaColors }),
                    deltaDescription &&
                        react_1.jsx(Text_1.default.Body, { css: dataMetricStyles.deltaDescription }, deltaDescription))) :
            undefined));
};
exports.default = DataMetric;
